import { gql, useApolloClient, useLazyQuery, useQuery } from '@apollo/client'
import { Box } from '@mui/material'
import {
	CreateQuote,
	GetAvailableWeights,
	GetPlan,
	GetPrice,
	GetQuote,
	ListProducts,
	Logger
} from '@wolfdanepug/common-react'
import BuilderForm from '../../../components/plan/BuilderForm'
import { useNavigate, useParams, useSearchParams } from 'react-router'
import { useCallback, useContext, useEffect } from 'react'
import { PageContext } from '../../../context/page'

export default function Plan() {
	const { plan: id } = useParams()
	const apollo = useApolloClient()
	const { setPage } = useContext(PageContext)
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()

	const createQuote = async ({ plan, selected, quote }: any) => {
		try {
			const { data } = await apollo.mutate({
				mutation: gql(CreateQuote),
				variables: {
					input: {
						type: 'plan-modification',
						data: [
							{
								plan,
								quote,
								products: selected
							}
						]
					}
				}
			})
			return data.createQuote
		} catch (e) {
			Logger.error(e)
		}
	}

	const handleCreateQuoteResponse = ({ id }: any) => {
		navigate(`/subscription/review/${id}`)
	}

	// Get the products data
	const { data: productsData } = useQuery(gql(ListProducts))
	// Get the plan data
	const { data: planData } = useQuery(gql(GetPlan), {
		variables: { id }
	})
	// Get the available weights
	const { data: weightsData } = useQuery(gql(GetAvailableWeights))
	// Get the quote data
	const [getQuote, { data: quoteData }] = useLazyQuery(gql(GetQuote))

	// Get the price of the quote
	const getPrice = useCallback(
		async ({ weight, term }: any) => {
			try {
				const { data } = await apollo.query({
					query: gql(GetPrice),
					variables: { weight, term }
				})
				return data.getPrice
			} catch (e) {
				Logger.error(e)
			}
		},
		[apollo]
	)

	useEffect(() => {
		const query = searchParams.get('q')
		query && getQuote({ variables: { id: query } })
	}, [getQuote, searchParams])

	useEffect(() => {
		setPage({
			title: 'Modify Plan',
			description: 'Modify your Subscription Plan',
			canGoBack: '/subscription',
			actions: [
				{
					label: 'Preview',
					event: 'save',
					enabled: true
				}
			],
			handlers: {
				save: createQuote
			},
			response: {
				save: handleCreateQuoteResponse
			}
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<Box
				sx={{
					width: '100%'
				}}
			>
				<BuilderForm
					plan={planData?.getPlan || {}}
					weights={weightsData?.getAvailableWeights.items || []}
					items={productsData?.listProducts?.items || []}
					updatePrice={getPrice}
					quote={quoteData?.getQuote || {}}
				/>
			</Box>
		</>
	)
}
